module.exports = __webpack_public_path__ + "img/xenolithed-ee8276d2-a5a5-4ab3-d669-08d957755ecc.png";